import { actions } from "./alert.actions";
import { selectors } from "./alert.selectors";

export const alert = {
  actions: actions,
  selectors: selectors,
};
